import { Redirect, Switch, useRouteMatch } from "react-router";
import RouteWrapper from "../helpers/RouteWrapper";

export function CreateModule({ baseUrl, navigation, layout }) {
  const match = useRouteMatch();
const links = navigation().links;
  return (
    <Switch>
      {links.map(({ route, component }) => (
        <RouteWrapper
          navigation={navigation}
          baseurl={baseUrl}
          key={route}
          path={`${match.url}/${route}`}
          component={component}
          layout={layout}
        />
      ))}
      <Redirect to={`${match.url}/${links[0].route}`} />
    </Switch>
  );
}
